///<reference path="../../services/treaty.service.ts"/>
import {AfterContentInit, AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TreatyApiService} from "../../services/treaty.service";
import { ITreatyState } from '../../store/reducers/treaty.reducer';
import {QueryProvider} from "@shared/queries/query-provider";
import {FileInfo, OtherDocument, TreatyDocumentContent, TreatyDocumentInfo} from "../../models/treaty.models";
import {take, takeUntil} from 'rxjs/operators';
import {select,Store} from "@ngrx/store";
import {Subject} from "rxjs";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";
import {HtmlConverterService} from "@shared/services/html-converter-api.service";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";
import {getOtherDocument} from "../../store/selectors/treaty.selector";
import {GetOtherDocumentInfoAction} from "../../store/actions/treaty.actions";
import {OffsetTopDirective} from "../../directives/offset-top.directive";
import {ScrollableDirective} from "../../directives/scrollable.directive";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {DownloadTreatyCommad} from "../../orbitax-treaty-command";
import {CommandService} from "@core/services/command.service";
import {getCurrentProject, ProjectState} from "../../../projects/store/reducers/projects.reducer";
import {ProjectModel} from "../../../projects/models/projects.models";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {SelectorModel} from '@shared/models/selector.model';
import {ItrceRatesConfig} from '@features/itrce-rates/itrce-rates.config';
import {PlatformCommand} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'particle-treaty-document',
  templateUrl: './treaty-document.component.html',
  styleUrls: ['./treaty-document.component.scss']
})
export class TreatyDocumentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isShowOtherDocumentOnly = false;
  currentDocumentId: string;
  dynamicInfo: { country1: any; country2: any; };
  otherVersionsContentViewEnable: boolean;
  ngUnsubscribe$ = new Subject<void>();
  fragment: string;
  treatyDocumentContent: TreatyDocumentContent;
  breadcrumbs$: any;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbKey: string;
  id: string;
  sidebarInfo: any;
  country1: string;
  country2: string;
  documentId: string;
  public otherVersions: FileInfo[];
  refresh: Subject<string>;
  fileInfo: FileInfo;
  private isCompact: boolean;
  unsubscribe$ = new Subject<void>();
  public currentProjectId: string;
  @Input() isShowBreadcrumbs = true;
  @Input() isShowActionItems = true;
  @Input() handler: any = null;
  constructor(private activatedRoute: ActivatedRoute,
              private dialogService: DialogService,
              private queryState: Store<IQueryState>,
              private htmlConverterService: HtmlConverterService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private treatyService: TreatyApiService, private projectStore: Store<ProjectState>,
              private commandService: CommandService, private fuseService: FuseSplashScreenService,
              private  router: Router, private treatyStore: Store<ITreatyState>) {
    this.breadcrumbKey = 'BreadcrumbByTreatyId';
    this.refresh = new Subject<string>();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    if (this.handler && this.handler.commandEmitter) {
      this.handler.commandEmitter.pipe(takeUntil(this.unsubscribe$)).subscribe(command => {
        switch (command.name) {
          case 'DownloadPdfCommand':
            this.downloadPDF();
            break;
          case 'PrintPageCommand':
            this.printPage();
            break;
        }
      });
    }
    this.isCompact = false;
    this.otherVersionsContentViewEnable = false;

    this.projectStore.pipe(select(getCurrentProject), takeUntil(this.unsubscribe$)).subscribe((project: ProjectModel) => {
      if (project) {
        this.currentProjectId = project.ProjectId;
      }
    });
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      this.treatyDocumentContent = null;

      this.country1 = params.countryOne;
      this.country2 = params.countryTwo;
      if (this.country1 && this.country2) {
        this.id = `treaties-${params.countryOne}-${params.countryTwo}`;
      }
      this.documentId = params.documentId;
      if (this.id) {
        this.sidebarInfo = {id: this.id};
      }
      let breadCrumbId = this.id;
      if (this.country1 && this.country2) {
        this.treatyService.getOtherVersions(this.country1, this.country2)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(data => {
            this.otherVersions = data;
            this.activateOtherVersionMenu();
          });
      }
      if (this.documentId) {
        this.fuseService.show();
        if (this.country1 && this.country2) {
          this.treatyService.getTreatyDocumentContentById(this.country1, this.country2, params.documentId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => this.processDocumentContent(data));
        } else {
          this.treatyService.getTreatyDocumentContentByIdOnly(params.documentId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => this.processDocumentContent(data));
        }
      } else {
        this.treatyService.getTreatyDocumentContent(this.country1, this.country2)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(data => this.processDocumentContent(data));
      }

      this.breadcrumbs$ = this.queryState.pipe(takeUntil(this.unsubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
    });

    this.activatedRoute.fragment
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(fragment => {
      this.fragment = fragment;
      if (this.treatyDocumentContent) {
        this.onItemSelection();
      }
    });

  }

  private printPage() {
    const element = document.getElementById('document-ngx-print') as HTMLElement;
    element.click();
  }

  private processDocumentContent(data: TreatyDocumentContent) {

    QueryProvider.invokeQuery(this.queryState, this.breadcrumbKey, {'[ID]': `${this.id}`, '[DOCUMENT_ID]': data.id});
    this.treatyDocumentContent = data;
    this.refresh.next(data.id);

    const activityInfo = {type: 'ReferenceCode', 'id': data.referenceCode, 'title': data.title, isDefault: false};
    this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));

    if(data.countryInfo) {
      this.dynamicInfo = {country1: data.countryInfo[0], country2: data.countryInfo[1]};
    }

    switch(data.contentType) {
      case "PDF": {
        this.fileInfo = <FileInfo> {
          id: data.id,
          title: data.title
        }
        this.activateOtherVersionMenu();
        this.otherVersionsContentViewEnable = true;
        break;
      }
      case "TreatyNews":
      case "TreatySummary":
      case "Dynamic":
      case "WithholdingTaxRates":{
        if(data.countryInfo) {
          this.dynamicInfo = {country1: data.countryInfo[0], country2: data.countryInfo[1]};
        }
        break;
      }
      default:
        this.treatyDocumentContent = data;
        this.fuseService.hide();
    }

    setTimeout(() => {
      this.onItemSelection();
    }, 1000);
  }

  ngAfterViewInit() {
    if (this.documentId) {
      this.refresh.next(this.documentId);
    }
  }


  onDocumentChanged(id: string) {
    this.refresh.next(id);
    this.currentDocumentId = id;
    if (this.country1 && this.country2) {
      this.router.navigateByUrl(`treaties/${this.country1}/${this.country2}/${id}`);
    } else {
      this.router.navigateByUrl(`treaties/${id}`);
    }

  }

  private getGroupId(group: string) {
    switch (group) {
      case 'documents':
        return 'treaty-documents';
      case 'social-security-documents':
        return 'social-security-documents'
      default:
        return 'other-documents';
    }
  }

  showArticle(event) {
    if(event.type == 'mli') {
      console.log("Event mli article :::",event.url);
      this.createMliArticleDialog(event.url);

    }
    else if(event.type == 'article') {
      this.fragment = event.url.toString().toUpperCase();
      this.onItemSelection();
    }
    else if(event.type == 'preamble') {
      const element = document.getElementById('preamble');
      if (element) {
        element.scrollIntoView(true);
        return true;
      }
    }
  }


  onItemSelection() {
    let item;
    this.treatyDocumentContent.articles.forEach(article => {
      article.isActive = false;
      if(article.articleTag == this.fragment) {
        item = article;
      }
    });
    let element = document.getElementById('top');
    if (item && item.articleTag) {
      item.isActive = true;
      element = document.getElementById(item.articleTag.toString().toUpperCase());
    }

    if (element) {
      element.scrollIntoView(true);
      return true;
    }
  }

  downloadPDF() {
    if (this.treatyDocumentContent && this.treatyDocumentContent.articles) {
      this.htmlConverterService.convertHtmlById('PDF', `${this.treatyDocumentContent.title}`, 'treatyDocument');
      const command = new DownloadTreatyCommad(this.treatyDocumentContent);
      this.commandService.executeCommand(command)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(x => {
        console.log("Ok");
      });
    }
  }
  otherVersionDisplay() {
    this.otherVersionsContentViewEnable = !this.otherVersionsContentViewEnable;
  }

  private createMliArticleDialog(articleId: string) {
    this.treatyService.getMliArticle(articleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(data => {
      const dialogModel = DialogModel.create(data.articleNo + "-" + data.articleTitle, 'MliArticleDialogComponent', { articleContent: data.content}, '800px', '400px');
      dialogModel.okCaption = "Open MLI Document";
      this.dialogService.showOkCancelDialog(dialogModel)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(actionState => {
          if(actionState && actionState.action == 'OK') {
            this.router.navigateByUrl(`treaties/${this.country1}/${this.country2}/mli#${articleId.toUpperCase()}`);
          }
        });

    });

  }
  showPdf(file: FileInfo) {
    this.fileInfo = null;
    this.router.navigateByUrl(`treaties/${this.country1}/${this.country2}/${file.id}`);
  }

  changeView() {
    this.isCompact = !this.isCompact;
  }



  public GetFile(fileId: string){
    console.log(fileId);
  }

  private activateOtherVersionMenu() {
    if(this.otherVersions && this.treatyDocumentContent) {
      this.otherVersions = this.otherVersions.map(d => {
        return {...d, isActive: this.treatyDocumentContent.id === d.id};
      });
      this.otherVersionsContentViewEnable = this.otherVersions.some(item => item.isActive);
    }
  }
}
